import Provider from '@/enums/Provider';
import IDescription from '@/interfaces/IDescription';
import IImage from '@/interfaces/IImage';
import UrlTypes from '@/enums/UrlTypes';
import { useNotificationStore } from '@/store/notificationStore';
import { extractImagesFromHtml } from '@/helpers/images/extractImagesFromHtml';
import { extractIOCategoryDescription } from './extractIOCategoryDescription';
import { extractERSCategoryDescription } from './extractERSCategoryDescription';
import { extractKBSCategoryDescription } from './extractKBSCategoryDescription';

export function extractCategoryDescription(
    htmlSource: string,
    pathname: string,
    provider: Provider
): IDescription {
    let descriptionHtml = '';
    const images: IImage[] = [];
    const notification = useNotificationStore();

    switch (provider) {
        case Provider.KBS:
            descriptionHtml = extractKBSCategoryDescription(htmlSource);
            break;
        case Provider.IO:
            descriptionHtml = extractIOCategoryDescription(htmlSource);
            break;
        case Provider.ERS:
            descriptionHtml = extractERSCategoryDescription(htmlSource);
            break;
        default:
            notification.addErrorNotification(
                `Unsupported provider: ${provider} for URL: ${pathname}`
            );
            break;
    }

    if (descriptionHtml) {
        images.push(
            ...extractImagesFromHtml(
                descriptionHtml,
                pathname,
                UrlTypes.CATEGORY_DESCRIPTION
            )
        );
    }

    return { pathname, descriptionHtml, images };
}
